<script setup lang="ts">
import ModalWithButtons from '@/components/Modal/ModalWithButtons.vue'
import { PlanTable } from './parts'

const emits = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <ModalWithButtons :max-width="'1200px'" @close="emits('close')">
    <template #title> プラン比較表 </template>
    <template #contents>
      <PlanTable :focus-on="[]" :body-height="'60vh'" />
    </template>
  </ModalWithButtons>
</template>

<style scoped>
/* css */
</style>
<textarea name="" id=""></textarea>
